import { getSavedState } from "./index";
export const bearerAuthHeader = () => {
    const token = getSavedState("token");
    if (token) {
        return {
            Authorization: "Bearer " + token,
        };
    } else {
        return null;
    }
};


export const oauthAuthHeader = () => {
    const accessToken = getSavedState("accessToken");
    const secretKey = getSavedState("secretKey");
    if (accessToken && secretKey) {
        return {
            "access-token": accessToken,
            "secret-key": secretKey,
            "Content-Type": "application/json"
        };
    } else {
        return null;
    }
};